import React, { useState, useEffect } from "react";
import countryService from "../../services/countryService";
import AppTable from "../../components/ui/AppTable";
import ListToolbar from "../../components/ui/ListToolbar";

const CountryList = ({ refreshTrigger }) => {
  const [countries, setCountries] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    loadCountries();
  }, [refreshTrigger]);

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, countries]);

  const loadCountries = async () => {
    try {
      setLoading(true);
      const response = await countryService.getAllCountries();
      if (response.success) {
        setCountries(response.data || []);
      }
    } catch (error) {
      console.error("Error loading countries:", error);
      setCountries([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    if (searchTerm.trim()) {
      try {
        const response = await countryService.searchCountries(searchTerm);
        if (response.success) {
          setFilteredCountries(response.data || []);
        }
      } catch (error) {
        console.error("Error searching countries:", error);
        setFilteredCountries(countries);
      }
    } else {
      setFilteredCountries(countries);
    }
  };

  const displayCountries =
    filteredCountries.length > 0 || searchTerm ? filteredCountries : countries;

  return (
    <div className="country-list">
      <ListToolbar
        title="Countries"
        subtitle={`${displayCountries.length} countr${displayCountries.length !== 1 ? "ies" : "y"} found`}
      >
        <div className="row g-3">
          <div className="col-md-6">
            <div className="input-group">
              <span className="input-group-text">
                <i className="fas fa-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search countries..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </ListToolbar>

      {/* Countries Table */}
      <div className="card border-0 shadow-sm">
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted mt-2">Loading countries...</p>
            </div>
          ) : displayCountries.length === 0 ? (
            <div className="text-center py-5">
              <i
                className="fas fa-globe text-muted mb-3"
                style={{ fontSize: "3rem" }}
              ></i>
              <h5 className="text-muted">No Countries Found</h5>
              <p className="text-muted">
                {searchTerm
                  ? "Try adjusting your search criteria."
                  : "No countries have been added yet."}
              </p>
            </div>
          ) : (
            <AppTable responsive>
                <thead>
                  <tr>
                    <th className="ps-4">Country</th>
                    <th className="text-center pe-4">ID</th>
                  </tr>
                </thead>
                <tbody>
                  {displayCountries.map((country) => (
                    <tr key={country.id} className="border-bottom">
                      <td className="ps-4">
                        <div className="d-flex align-items-center">
                          <div
                            className="country-icon rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center me-3"
                            style={{ width: "45px", height: "45px" }}
                          >
                            <i className="fas fa-flag text-success"></i>
                          </div>
                          <div>
                            <div className="fw-bold text-dark">
                              {country.name}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="text-center pe-4">
                        <span className="badge bg-primary">{country.id}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
            </AppTable>
          )}
        </div>
      </div>
    </div>
  );
};

export default CountryList;
